<script>
  export let name;
</script>

<main>
  <h2>Linn Forsman</h2>
  <h3>Data Science</h3>
  <h1>{name}!</h1>
  <p>Site is currently under construction. Please visit back another time.</p>
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  h1,
  h2 {
    color: #0077ff;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }

  h3 {
    font-size: 2.7em;
    font-weight: 100;
  }
  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
